<div class="row">
  <div class="col-sm-6">
    <h2>{{ buttonTitle }}</h2>
  </div>
  <div class="col-sm-6">
    <button type="button" style="float: right" class="btn btn-secondary px-4" (click)="onCancel()">
      Cancel
    </button>
    <button
      type="button"
      (click)="onSubmit()"
      style="float: right; margin-right: 15px"
      class="btn btn-primary px-4"
    >
      {{ isEditMode ? 'Update' : 'Save' }}
    </button>
  </div>
</div>

<!-- Chain Details Form -->
<div class="col-12" style="margin-top: 30px">
  <nb-card>
    <nb-card-header>Chain Details</nb-card-header>
    <nb-card-body>
      <form [formGroup]="chainForm">
        <div class="row">
          <div class="col-sm-6">
            <label class="form-label">Chain Name <span class="text-danger">*</span></label>
            <input
              class="form-control"
              placeholder="Enter Chain Name"
              formControlName="chainName"
              nbInput
            />
          </div>
          <div class="col-sm-6">
            <label class="form-label">Description</label>
            <input
              class="form-control"
              placeholder="Enter Description (optional)"
              formControlName="description"
              nbInput
            />
          </div>
        </div>
      </form>
    </nb-card-body>
  </nb-card>
</div>

<!-- Edit Mode: Stores Section -->
<div class="col-12" style="margin-top: 20px" *ngIf="isEditMode">
  <nb-card>
    <nb-card-header>
      <div class="d-flex justify-content-between align-items-center">
        <span>Stores in Chain</span>
        <div class="d-flex align-items-center gap-2">
          <ng-select
            [(ngModel)]="selectedStoreId"
            placeholder="Select a store to add"
            style="min-width: 250px"
          >
            <ng-option *ngFor="let store of availableStores" [value]="store._id">
              {{ store.storeName }}
            </ng-option>
          </ng-select>
          <button
            type="button"
            class="btn btn-primary btn-sm ms-2"
            [disabled]="!selectedStoreId"
            (click)="addStore()"
          >
            Add Store
          </button>
        </div>
      </div>
    </nb-card-header>
    <nb-card-body>
      <table class="table text-center">
        <thead>
          <tr>
            <th>Store Name</th>
            <th>Address</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let store of chainStores">
            <td>{{ store.storeName || store._id }}</td>
            <td>{{ store.address || '-' }}</td>
            <td>{{ getStoreStatus(store) }}</td>
            <td>
              <nb-icon
                style="cursor: pointer"
                (click)="removeStore(store)"
                class="deleteIcon"
                icon="trash-outline"
                nbTooltip="Remove from chain"
              ></nb-icon>
            </td>
          </tr>
          <tr *ngIf="chainStores.length === 0">
            <td colspan="4" class="text-center" style="color: #888; padding: 20px">
              No stores in this chain yet.
            </td>
          </tr>
        </tbody>
      </table>
    </nb-card-body>
  </nb-card>
</div>

<!-- Edit Mode: Managers Section -->
<div class="col-12" style="margin-top: 20px" *ngIf="isEditMode">
  <nb-card>
    <nb-card-header>
      <div class="d-flex justify-content-between align-items-center">
        <span>Assigned Managers</span>
        <div class="d-flex align-items-center gap-2">
          <ng-select
            [(ngModel)]="selectedAdminId"
            placeholder="Select manager to assign"
            style="min-width: 250px"
          >
            <ng-option *ngFor="let admin of availableAdmins" [value]="admin._id">
              {{ admin.name }} ({{ admin.role }})
            </ng-option>
          </ng-select>
          <button
            type="button"
            class="btn btn-primary btn-sm ms-2"
            [disabled]="!selectedAdminId"
            (click)="assignManager()"
          >
            Assign Manager
          </button>
        </div>
      </div>
    </nb-card-header>
    <nb-card-body>
      <table class="table text-center">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Last Login</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let manager of chainManagers">
            <td>{{ manager.name }}</td>
            <td>{{ manager.email }}</td>
            <td>{{ manager.role }}</td>
            <td>{{ getLastLogin(manager) }}</td>
            <td>
              <nb-icon
                style="cursor: pointer"
                (click)="removeManager(manager)"
                class="deleteIcon"
                icon="trash-outline"
                nbTooltip="Remove from chain"
              ></nb-icon>
            </td>
          </tr>
          <tr *ngIf="chainManagers.length === 0">
            <td colspan="5" class="text-center" style="color: #888; padding: 20px">
              No managers assigned yet.
            </td>
          </tr>
        </tbody>
      </table>
    </nb-card-body>
  </nb-card>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus">
  <p style="color: white">Loading...</p>
</ngx-spinner>
